import PropTypes from 'prop-types';
import { forwardRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';
// project imports
import { MENU_OPEN, SET_MENU } from 'store/actions';
// assets
import { useProfile } from 'views/utilities/useProfile';

const NavItem = ({ item, level }) => {
  const { state } = useProfile();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const customization = useSelector((state) => state.customization);
  const matchesSM = useMediaQuery(theme.breakpoints.down('lg'));

  const allowedRoutesDistributor = ["/user", "/dashboard", "/distributor-reseller", "/distributor-customer", "/distributor-subscription", "/account-profile", "/activity-log", "/order"];
  const allowedRoutesReseller = ["/user", "/dashboard", "/reseller-customer", "/reseller-subscription", "/account-profile", "/activity-log", "/order"];
  const allowedRoutesCustomer = ["/user", "/dashboard", "/customer-subscription", "/account-profile", "/activity-log", "/order"];
  const notAllowedRoutesUser = ["/user"];
  const previousPagePath = "/dashboard"; // Replace with your desired fallback page

  useEffect(() => {
    if (state?.role_id === 2 && !state?.company_user_id > 0) {
      if (!allowedRoutesDistributor.includes(pathname)) {
        window.location.href = previousPagePath;
      }
    }
    if (state?.role_id === 3 && !state?.company_user_id > 0) {
      if (!allowedRoutesReseller.includes(pathname)) {
        window.location.href = previousPagePath;
      }
    }
    if (state?.role_id === 4 && !state?.company_user_id > 0) {
      if (!allowedRoutesCustomer.includes(pathname)) {
        window.location.href = previousPagePath;
      }
    }
    if (state?.company_user_id > 0) {
      if (notAllowedRoutesUser.includes(pathname)) {
        window.location.href = previousPagePath;
      }
    }
    // eslint-disable-next-line
  }, [pathname, state]);

  let itemTarget = '_self';
  if (item.target) {
    itemTarget = '_blank';
  }

  let listItemProps = {
    component: forwardRef((props, ref) => <Link ref={ref} {...props} to={item.url} target={itemTarget} />)
  };
  if (item?.external) {
    listItemProps = { component: 'a', href: item.url, target: itemTarget };
  }

  const itemHandler = (id) => {
    dispatch({ type: MENU_OPEN, id });
    if (matchesSM) dispatch({ type: SET_MENU, opened: false });
  };

  // active menu item on page load
  useEffect(() => {
    const currentIndex = document.location.pathname
      .toString()
      .split('/')
      .findIndex((id) => id === item.id);
    if (currentIndex > -1) {
      dispatch({ type: MENU_OPEN, id: item.id });
    }
    // eslint-disable-next-line
  }, [pathname]);

  return (
    <ListItemButton
      {...listItemProps}
      disabled={item.disabled}
      sx={{
        borderRadius: `${customization.borderRadius}px`,
        mb: 0.5,
        alignItems: 'flex-start',
        backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
        py: level > 1 ? 1 : 1.25,
        pl: `${level * 24}px`
      }}
      selected={customization.isOpen.findIndex((id) => id === item.id) > -1}
      onClick={() => itemHandler(item.id)}
    >
      <ListItemIcon sx={{ my: 'auto', minWidth: !item?.icon ? 18 : 36 }}> <i className={item.icon} style={{ fontSize: '1.3rem' }} /> </ListItemIcon>
      <ListItemText
        primary={
          <Typography variant={customization.isOpen.findIndex((id) => id === item.id) > -1 ? 'h5' : 'body1'} color="inherit">
            {item.title}
          </Typography>
        }
        secondary={
          item.caption && (
            <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
              {item.caption}
            </Typography>
          )
        }
      />
      {item.chip && (
        <Chip
          color={item.chip.color}
          variant={item.chip.variant}
          size={item.chip.size}
          label={item.chip.label}
          avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
        />
      )}
    </ListItemButton>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number
};

export default NavItem;
